<div class="row" *ngIf="taskTemplate">
  <div class="text-center mt-2">
    <a [routerLink]="['/task/template/sample',taskTemplate.id]" class="btn btn-primary me-2" >
      <i class="fa fa-eye"></i> View Sample
    </a>

      <a [routerLink]="['/task/template/edit',taskTemplate.id]" class="btn btn-primary me-2" >
        <i class="fa fa-edit"></i> Edit
      </a>
      <a [routerLink]="['/task/template/list']" class="btn btn-primary" >
        <i class="fa fa-list"></i>  List</a>
  </div>

  <div class="col-sm-12">
    <table class="table table-condensed table-striped">
    <tbody>
    <tr><td width="10%">Name</td><td>{{taskTemplate.name}}</td></tr>
    <tr><td>Answer Template</td><td>
      <a [routerLink]="['/answer/template/show',taskTemplate.server_answer_template_id]" class="me-2">
      {{taskTemplate.answerTemplateName}}
      </a>
      <button *ngIf="taskTemplate.answerTemplateName!=''" class="delete btn btn-danger" (click)="confirmRemove()" > X </button>
    </td></tr>
    <tr><td width="10%">Disable Quiz Count</td><td>{{taskTemplate.disable_quiz_count}}</td></tr>
    <tr>
      <td>Tags</td>
      <td>{{taskTemplate.comment}}</td>
    </tr>
    <tr>
      <td>Description</td>
      <td><app-task-description [description]="taskTemplate.description"></app-task-description></td>
    </tr>

    <tr><td>Sub Topics</td><td>
      <div *ngFor="let sTopic of taskTemplate.subTopics;">
        {{sTopic}}
      </div>

    </td></tr>
    <tr><td>Enabled</td>
      <td>
        <input type="checkbox" [name]="myCheckbox" (click)="enableDisable()" [checked]="taskTemplate.enabled==1" />

      </td></tr>
      <tr><td>Quiz Mode</td>
        <td>
          <ul>
            <li *ngFor="let qMode of taskTemplate.quizModes;myCount as index">
              <input type="checkbox" [name]="myCheckboxMode" (click)="enableDisableMode(qMode.id)" [checked]="true" *ngIf="qMode.is_in" />
              <input type="checkbox" [name]="myCheckboxMode" (click)="enableDisableMode(qMode.id)" *ngIf="!qMode.is_in" />
              {{qMode.name}}
            </li>
          </ul>
         </td>
        </tr>

    </tbody>
    </table>
  </div>
</div>
<div class="row" *ngIf="taskTemplate">
  <div class="col-sm-12">
    <app-task-template-ability [taskTemplate]="taskTemplate"></app-task-template-ability>
  </div>

</div>
<div class="row"  *ngIf="taskTemplate">
  <div class="col-sm-12">

    <a [routerLink]="['/task/template/list']" class="btn btn-primary m-2" >
      <i class="fa fa-list"></i>  List</a>


    <a [routerLink]="['/task/template/edit',taskTemplate.id]" class="btn btn-primary m-2" >
      <i class="fa fa-edit"></i> Edit
    </a>


  <a [routerLink]="['/task/template/answer/add',taskTemplate.id]" class="btn btn-primary m-2" >
    <i class="fa fa-link"></i> Link To  Solution
  </a>

  <a [routerLink]="['/answer/template/create']" class="btn btn-primary m-2" >
    <i class="fa fa-plus"></i> Load New To Solution
  </a>


  <a [routerLink]="['/task/template/mode/edit',taskTemplate.id]" class="btn btn-primary m-2" >
    <i class="fa fa-edit"></i> Edit Quiz Modes
  </a>





  <button  (click)="renameTemplate()" class="btn btn-primary me-3" >
    <i class="fa fa-edit"></i> Rename Template
  </button>


  <a [routerLink]="['/task/template/questions',taskTemplate.id]" class="btn btn-primary m-2" >
    <i class="fa fa-eye"></i> Show Questions
  </a>


  <a [routerLink]="['/task/template/replace',taskTemplate.id]" class="btn btn-primary m-2" >
    <i class="fa fa-pen"></i> Replace Template
  </a>


<button class="btn btn-danger m-2" (click)="deleteTemplate()" >Delete</button>
</div>
</div>
<app-question-template-rename [taskTemplate]="taskTemplate" (editQuestionTemplateFinishEvent)="reloadTemplate()"  *ngIf="taskTemplate"></app-question-template-rename>
